import { render, staticRenderFns } from "./shuiqiuChart.vue?vue&type=template&id=60bad36e&"
import script from "./shuiqiuChart.vue?vue&type=script&lang=js&"
export * from "./shuiqiuChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports